import { Input } from 'components/core';

interface TextBoxProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
}

// Plain text box that hands back the typed string. The editor wraps the tabs in a form, so Enter must not save it.
export const TextBox = ({ value, placeholder, onChange }: TextBoxProps) => (
  <Input
    showTitle={false}
    showDescription={false}
    ignoreEnter
    placeholder={placeholder}
    value={value}
    onChange={(e: { target: { value: string } }) => onChange(e.target.value)}
  />
);
